export class ContentDetailData {
  contentCategoryID!: number;
  contentCategoryIcon!: string;
  contentCategoryName!: string;
  contentDetailID!: number;
  details!: string;
  docFileName!: string;
  sequence!: number;
  seq!: number;
  shipID: any;
  shipsManagerOwnerID: any;
  title!: string;
  spanColumnCount!: number;
}
